import intlTelInput from "intl-tel-input";
const inputTarget = document.querySelector("#phone-field");

if (inputTarget) {
  intlTelInput(inputTarget, {
    loadUtils: () => import("intl-tel-input/utils"),
    initialCountry: "do",
    separateDialCode: true,
    autoPlaceholder: "off",
    hiddenInput: function (_telInputName) {
      return {
        phone: "phone_number",
        country: "country_code",
      };
    },
  });
}

document.addEventListener("turbo:load", () => {
  const inputTarget = document.querySelector("#phone-field");
  if (inputTarget) {
    intlTelInput(inputTarget, {
      loadUtils: () => import("intl-tel-input/utils"),
      initialCountry: "do",
      separateDialCode: true,
      autoPlaceholder: "off",
      hiddenInput: function (_telInputName) {
        return {
          phone: "phone_number",
          country: "country_code",
        };
      },
    });
  }
});

document.addEventListener("turbo:before-render", (e) => {
  const inputTarget = e.detail.newBody.querySelector("#phone-field");
  if (inputTarget) {
    intlTelInput(inputTarget, {
      loadUtils: () => import("intl-tel-input/utils"),
      initialCountry: "do",
      separateDialCode: true,
      autoPlaceholder: "off",
      hiddenInput: function (_telInputName) {
        return {
          phone: "phone_number",
          country: "country_code",
        };
      },
    });
  }
});
